export const settledEnterprise = `/api/oauth/enterprise/updateEnterprise`; // 企业入驻
export const queryCurrentEnt = `/api/oauth/enterprise/getEnterprise`; // 获取当前企业信息
export const queryEntByKeyword = `/api/unoauth/enterprise/selectEnterprise`; // 根据关键字查询企业
export const toJoinEnterprise = `/api/oauth/relation/insertEnterpriseUserRelation`; // 申请加入企业信息
export const queryUserEnterpriseStatus = `/api/oauth/relation/singletonEnterpriseUserRelationRespond`;
export const queryUserInEnterprise = `/api/oauth/relation/selectEnterpriseUserRelationPage`; // 查询企业关联的用户
export const applyEntChecking = `/api/oauth/relation/updateEnterpriseUserRelation`; // 审核用户加入企业
// 保存企业信息
export const saveEntInfo = `/api/oauth/enterprise/saveEnterpriseInfo`;
